import { parseTargetRef } from "@entities/generation-setting";

import { isDeckLoaded, locate, refreshDeck } from "./deckStore";
import { selectSlide, selectShapeOnSlide } from "./powerpointRunner";

/**
 * ターゲット参照（`slide:<識別子>` / `element:<識別子>`）を PowerPoint 上で選択・表示する。
 *
 * 在り処は走査結果から引く。走査は `deckStore` が全枚ぶんの対応を持っているので、ここでの
 * 引き当てに PowerPoint への往復は要らない。まだ走査が済んでいなければ一度だけ待つ。
 *
 * 旧実装は creationId で全スライドを走査し、結果を `im.caches.shapeIds` へ書いていた。
 * 走査が 1 箇所へ集まったことで、その走査もキャッシュも不要になった。
 */
export async function navigateToTarget(ref: string): Promise<"ok" | "not-found"> {
    const { kind, officeId } = parseTargetRef(ref);

    if (!isDeckLoaded()) await refreshDeck();

    let at = locate(officeId);
    if (at === null) {
        // 図形が動いた・増えた直後は取りこぼす。一度だけ読み直してから諦める。
        await refreshDeck();
        at = locate(officeId);
    }
    if (at === null) return "not-found";

    try {
        if (kind === "slide" || at.officeShapeId === undefined) {
            await selectSlide(at.officeSlideId);
        } else {
            await selectShapeOnSlide(at.officeSlideId, at.officeShapeId);
        }
        return "ok";
    } catch {
        return "not-found";
    }
}
